/**
 * @generated SignedSource<<c7bd81a1b97b568fb9f43c027f4fe220>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RepositoryCardSubscription$variables = {
  repositoryID: string;
};
export type RepositoryCardSubscription$data = {
  readonly repository: {
    readonly " $fragmentSpreads": FragmentRefs<"RepositoryCard_repository">;
  } | null;
};
export type RepositoryCardSubscription = {
  response: RepositoryCardSubscription$data;
  variables: RepositoryCardSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "repositoryID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "repositoryID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "owner",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RepositoryCardSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RepositoryCard_repository"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RepositoryCardSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "platform",
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerPermission",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "lastDefaultBranchBuild",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "branch",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "changeMessageTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "buildCreatedTimestamp",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "changeIdInRepo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPausedTasks",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2c8ed70d0041f24cef9ed44d71f61d38",
    "id": null,
    "metadata": {},
    "name": "RepositoryCardSubscription",
    "operationKind": "subscription",
    "text": "subscription RepositoryCardSubscription(\n  $repositoryID: ID!\n) {\n  repository(id: $repositoryID) {\n    ...RepositoryCard_repository\n    id\n  }\n}\n\nfragment BuildBranchNameChipNew_build on Build {\n  id\n  branch\n  tag\n  repository {\n    id\n    owner\n    name\n  }\n}\n\nfragment BuildStatusChipNew_build on Build {\n  id\n  status\n  hasPausedTasks\n}\n\nfragment CreatedTime_build on Build {\n  buildCreatedTimestamp\n}\n\nfragment Hash_build on Build {\n  changeIdInRepo\n}\n\nfragment RepositoryCard_repository on Repository {\n  id\n  platform\n  owner\n  name\n  viewerPermission\n  lastDefaultBranchBuild {\n    id\n    branch\n    changeMessageTitle\n    ...CreatedTime_build\n    ...Hash_build\n    ...BuildStatusChipNew_build\n    ...BuildBranchNameChipNew_build\n  }\n}\n"
  }
};
})();

(node as any).hash = "65b6c18dce289d13f72f622a9839e573";

export default node;
